import { useRef } from "react";
import { FormProvider, type UseFormReturn } from "react-hook-form";
import { DialogComponent, Popover, TriggerButton, TriggerButtonSize } from "widgets";
import { useFormAria, useOverlay } from "widgets/hooks";

import { ExportForm } from "./ExportForm.tsx";
import { useExportPopover } from "./hooks.ts";
import type { ExportFormValues } from "./utils.ts";

export const ExportButton = () => {
  const methods = useFormAria<ExportFormValues>({
    defaultValues: {
      compressed: true,
      reverse: false,
      fileName: "",
    },
    shouldUnregister: true, // Hidden fields removed values
    mode: "onChange",
    reValidateMode: "onChange",
  });

  return (
    <FormProvider
      data-testid="export-form"
      {...(methods as unknown as UseFormReturn<ExportFormValues, unknown, ExportFormValues>)}
    >
      <ExportPopover />
    </FormProvider>
  );
};

const ExportPopover = () => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const { overlayProps, state } = useOverlay();
  const { isFormInvalid, isLoading, onExportSubmit, errorMessage } = useExportPopover(state);
  return (
    <>
      <TriggerButton
        icon={"cloud_download"}
        size={TriggerButtonSize.Normal}
        onPress={state.open}
        label={"Export"}
        showLabel
        ref={triggerRef}
      />
      <Popover state={state} {...overlayProps} triggerRef={triggerRef} placement="bottom end">
        <DialogComponent
          data-testid="export-popover"
          mainButton={{
            label: "Export",
            onPress: () => onExportSubmit(),
            isLoading: isLoading,
            isDisabled: isFormInvalid,
          }}
          closeFn={() => {
            if (!isLoading) {
              state.close();
            }
          }}
          width={500}
          asPanelHeader
          errorCallout={errorMessage ? { message: errorMessage } : undefined}
        >
          <ExportForm />
        </DialogComponent>
      </Popover>
    </>
  );
};
